import './util-category.scss';

import { Outlet } from "react-router-dom";

import { FilterUtilCategoryProvider } from "./filter-util-category/filter-util-category.context";

export function UtilCategory() {
  return (
    <div id="ShellUtilCategory" className="util-category">
       <FilterUtilCategoryProvider>
        <Outlet />
      </FilterUtilCategoryProvider>
    </div>
  );
}

export default UtilCategory;
